export enum SelectSizes {
  Icon,
  Tiny,
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
